import { userGuiding } from "@/_old/lib/user-guiding";

userGuiding.initialize();
